import type { IRuntimeState } from "../types/state.types.ts"

export class RuntimeStateClass implements IRuntimeState {
    isLoading = [] as string[]
    isEmbed = false
    isGeneratingPdf = false
}
